import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class RecipeService {
    static getRecipes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`recipes?filter=${qs}`, pageNumber));
    }
    static fetchRecipe(oid) {
        return lastValueFrom(BaseService.get(`recipes/${oid}`));
    }
    static saveRecipe(dto) {
        return lastValueFrom(BaseService.save(`recipes`, dto));
    }
    static deleteRecipe(oid) {
        return lastValueFrom(BaseService.delete(`recipes/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Search dropdown
    // ----------------------------------------------------------------------
    static searchRecipeCombo(selfId, productTypeId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`recipes-search-dropdown/${selfId}/${productTypeId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Recipe Ingredients
    // ----------------------------------------------------------------------
    static getRecipeIngredients(recipeId) {
        return lastValueFrom(BaseService.get(`recipe-ingredients/${recipeId}`));
    }
    static saveRecipeIngredient(dto) {
        return lastValueFrom(BaseService.post(`recipe-ingredients`, dto));
    }
    static deleteRecipeIngredient(oid) {
        return lastValueFrom(BaseService.delete(`recipe-ingredients/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Recipe Materials
    // ----------------------------------------------------------------------
    static getRecipeMaterials(recipeId) {
        return lastValueFrom(BaseService.get(`recipe-materials/${recipeId}`));
    }
    static saveRecipeMaterial(dto) {
        return lastValueFrom(BaseService.post(`recipe-materials`, dto));
    }
    static deleteRecipeMaterial(oid) {
        return lastValueFrom(BaseService.delete(`recipe-materials/${oid}`));
    }
}
